// extracted by mini-css-extract-plugin
export var container = "_72-0";